import React from 'react';
import PropTypes from 'prop-types';
import MUIButton from '@material-ui/core/Button';
import style from './ButtonBase.style';

const ButtonBase = React.forwardRef(
  (
    {
      children,
      type,
      disabled,
      selected,
      className,
      onClick,
      context,
      ...otherProps
    },
    ref
  ) => (
    <MUIButton
      css={style.container.base({ type, selected, context })}
      className={className}
      disabled={disabled}
      onClick={onClick}
      disableRipple
      disableFocusRipple
      {...otherProps}
      aria-pressed={selected}
      ref={ref}
    >
      {children}
    </MUIButton>
  )
);

ButtonBase.defaultProps = {
  type: 'secondary',
  disabled: false,
  selected: false,
  className: undefined,
  onClick: undefined,
};

ButtonBase.propTypes = {
  type: PropTypes.string,
  context: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

ButtonBase.displayName = 'ButtonBase';

export default React.memo(ButtonBase);
